<template>
  <div class="container loginMain">
    <div class="sz_login">
      <div class="logo">
        <img src="../assets/greenlogo.png" />
        <span class="sz_login_title">上海市绿色建筑协会会员系统</span>
      </div>
      <div class="sz-tip">
        <img src="../assets/qrcode2.png" />
        <p style="text-align: left;">注：会员单位输入用户名和密码后可直接登录访问，如您还不是会员，直接点击“申请入会”进行信息填写。</p>
      </div>
      <div class="login_right">
        <div class="sz_login_box">
          <img src="../assets/user.png" />
          <div class="sz_login_line"></div>
          <input type="text" v-model="username" placeholder="请输入用户名或联系人手机" />
        </div>
        <div class="sz_login_box">
          <img src="../assets/password.png" />
          <div class="sz_login_line"></div>
          <input type="password" v-model="password" placeholder="请输入密码" />
        </div>
        <div class="bottom_btns">
          <el-checkbox name="remember" v-model="rememberPwd" />
          <span class="remember_text">记住密码</span>
          <span class="forget-password">
            <router-link to="/forgetPwd">忘记密码</router-link>
          </span>
        </div>
        <div class="sz_login_bottom" @click="login();">登 录</div>
        <div class="sz_register_bottom" @click="register()">
          申请入会
          <span>(用户注册)</span>
        </div>
      </div>
    </div>
    <div id="KBStatic">
      <p>推荐使用谷歌、火狐浏览器。</p>
      <p>IE浏览器可能存在不兼容性。在使用QQ、360浏览器时请切换至极速模式</p>
    </div>
    <el-dialog
      title="协会介绍"
      width="800px"
      top="20vh"
      center
      :visible="showDialog"
      :before-close="handleClose"
      :close-on-click-modal="closeOnClickModal"
      :close-on-press-escape="closeOnPressEscape"
    >
      <div>
        <div style="text-align: center;vertical-align:middle;margin-bottom: 15px;">
          <img src="../assets/logo.png" style="width: 45%" />
        </div>
        <p
          class="indentation"
        >2013年6月，经上海市社团管理局和上海市住房和城乡建设管理委员会（原上海市城乡建设和交通委员会）批准，上海市绿色建筑协会在原上海市绿色建筑促进会和上海市绿色建筑与节能专业委员会的基础上成立了上海市绿色建筑协会，确定了“以服务会员单位需求为宗旨、以政府工作要求为导向”的工作思路。主要由从事绿色建筑的科研、规划、设计、开发、施工、教育、信息管理、服务及相关设备、材料生产企业自愿参加的非营利性社会团体协会。</p>
        <p class="indentation">
          协会官网：
          <a
            href="http://www.shgbc.org"
            target="_blank"
            style="color: #00B0F0;text-decoration: underline;"
          >www.shgbc.org</a>
        </p>
        <p class="indentation">联系电话：021-64083368</p>
      </div>
      <div style="margin-top: 20px;text-align: center">
        <el-button type="primary" size="mini" @click="showDialog = false">上一步</el-button>
        <el-button type="primary" size="mini" @click="toRegist">下一步</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import { setUserInfo, getUserInfo } from '../utils/cache'

export default {
  name: 'Login',
  data () {
    return {
      rememberPwd: false,
      username: '',
      password: '',
      showDialog: false,
      closeOnClickModal: false,
      closeOnPressEscape: false
    }
  },
  mounted () {
    if (localStorage.getItem('username_worthiest')) {
      this.username = localStorage.getItem('username_worthiest')
    }
    if (localStorage.getItem('password_worthiest')) {
      this.password = localStorage.getItem('password_worthiest')
    }
    if (this.username && this.password) {
      this.rememberPwd = true
    }
  },
  methods: {
    // 加密
    encrypt (word) {
      const CryptoJS = window.CryptoJS
      var password = word
      var key = CryptoJS.enc.Utf8.parse('aedrfgasdvcnjokl')
      var iv = CryptoJS.enc.Utf8.parse('aedrfgasdvcnjokl')
      return CryptoJS.AES.encrypt(password, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.ZeroPadding
      }).toString()
    },
    // 登录
    login () {
      if (!this.username) {
        this.$message.error('请输入用户名或手机号')
        return
      }
      if (!this.password) {
        this.$message.error('请输入密码')
        return
      }
      var params = {
        username: this.username,
        password: this.password
      }
      API.memUserLogin(params).then(response => {
        if (response.resultCode === '0000') {
          setUserInfo(response.data)
          this.$store.commit('changeUserName', response.data.username)
          if (this.rememberPwd) {
            localStorage.setItem('username_worthiest', this.username)
            localStorage.setItem('password_worthiest', this.password)
          } else {
            localStorage.removeItem('username_worthiest')
            localStorage.removeItem('password_worthiest')
          }
          let params = {
            userid: getUserInfo().id
          }
          API.findOneInfo(params).then(resp => {
            if (resp.resultCode === '0000') {
              if (resp.data) {
                if (resp.data.memberno) { // 有数据有编号
                  this.$router.push('/')
                } else {
                  this.$router.push('/notMemberMiddleWare')
                }
              } else {
                this.$router.push('/applicationInfo')
              }
            } 
          })  
        } else {
          this.$message.error(response.resultMsg)
        }
      })
    },
    // 注册
    register () {
      this.showDialog = true
    },
    handleClose () {
      this.showDialog = false
    },
    toRegist () {
      this.$router.push('/register')
    }
  }
}
</script>

<style lang="scss">
.loginMain {
  width: 100%;
  background: url("../assets/bg.png") 100% 100% no-repeat;
  background-size: cover;
  position: relative;
  margin: 0;
  padding: 0;
  text-align: center;
}
.el-message-box__header {
  padding: 25px 15px 20px;
}
.el-message-box__headerbtn {
  top: 50%;
  transform: translate(0, -50%);
}
.el-message-box--center .el-message-box__title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
footer {
  position: fixed;
  width: 100%;
  height: 30px;
  bottom: 0;
  background: linear-gradient(transparent, #326272);
  color: #fff;
  font-size: 14px;
}
#KBStatic {
    width: 572px;
    height: 50px;
    text-align: center;
    opacity: 0.8;
    background: #fff;
    color: red;
    top: 75%;
    position: absolute;
    left: 50%;
    margin-left: -286px;
}
.sz_login {
  width: 572px;
  height: 380px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 1);
}
.login_right {
  width: 296px;
  float: right;
}
.sz_login_text {
  font-size: 12px;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
  margin-left: -120px;
}
.sz_login_img {
  vertical-align: middle;
  width: 139px;
  height: 42px;
}
.sz_login_box {
  background: transparent;
  width: 255px;
  height: 45px;
  margin-bottom: 20px;
  position: relative;
  border-bottom: 1px solid #737383;
}
.sz_login_box img {
  float: left;
  margin-top: 8px;
  margin-left: 5px;
  width: 26px;
  height: 28px;
}
.sz_login_line {
  width: 1px;
  height: 25px;
  background: #979797;
  float: left;
  margin-top: 8px;
  margin-left: 12px;
}
.sz_login_box input {
  width: 180px;
  height: 30px;
  font-size: 15px;
  color: #333;
  line-height: 55px;
  border: none;
  outline: none;
  margin-left: 5px;
  margin-top: 5px;
  border-radius: 7px;
  background-color: transparent;
}
.bottom_btns {
  text-align: left;
  width: 255px;
}
.bottom_btns .remember_text {
  display: inline-block;
  font-size: 15px;
  color: #7c7c7c;
  line-height: 21px;
}
.bottom_btns .forget-password {
  float: right;
}
.bottom_btns .forget-password a {
  display: inline-block;
  font-size: 15px;
  color: #7c7c7c;
  line-height: 21px;
}
.bottom_btns .forget-password a:hover {
  color: #1665c1;
}
.sz_login_bottom {
  background: #0096cc;
  border-radius: 20px;
  width: 255px;
  height: 36px;
  margin-top: 20px;
  font-size: 16px;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}
.sz_register_bottom {
  background: transparent;
  border-radius: 20px;
  border: 1px solid #0096cc;
  width: 255px;
  height: 36px;
  margin-top: 20px;
  font-size: 16px;
  color: #0096cc;
  text-align: center;
  line-height: 36px;
  cursor: pointer;
}
.sz_register_bottom:hover {
  border-color: #1665c1;
  color: #1665c1;
}
.sz_register_bottom span {
  margin-left: 6px;
}
.sz_login_bottom:hover {
  background: #1665c1;
}
.sz_small_title {
  color: #a4a4a4;
  font-size: 14px;
  float: right;
  margin-right: 110px;
  border-bottom: 1px solid #a4a4a4;
}
.password_remember {
  text-align: left;
  width: 110px;
  margin-left: 49%;
  margin-top: -10px;
  font-size: 13px;
}
.remenber_text {
  color: #a4a4a4;
}
.bottom_btns a {
  color: #7c7c7c;
  font-size: 13px;
  text-decoration: none;
}
#w_fpwd {
  width: 100%;
  height: 72px;
  background: rgba(248, 248, 248, 1);
  opacity: 0.68;
}

.forgetpwd_hint > img,
.forgetpwd_hint > span {
  vertical-align: middle;
}
.forgetpwd_hint:after {
  display: inline-block;
  width: 0;
  height: 100%;
  vertical-align: middle;
  content: "";
}

.sz_login .logo {
  margin: 20px 0;
  display: inline-block;
  text-align: center;
}
.sz_login .logo:after {
  content: "";
  display: block;
  clear: both;
}
.sz_login .logo img {
  width: auto;
  height: 36px;
  float: left;
}
.sz_login_title {
  float: left;
  font-size: 28px;
  font-family: MicrosoftYaHei;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 36px;
  margin-top: 6px;
  margin-left: 6px;
}
.sz-tip {
  width: 276px;
  float: left;
  text-align: center;
}
.sz-tip img {
  width: 200px;
}
.sz-tip p {
  font-size: 15px;
  color: #7c7c7c;
  line-height: 18px;
  padding: 0px 30px;
  font-weight: bold;
}
.indentation {
  text-indent: 2em;
  color: #535050;
  font-weight: 400;
  line-height: 30px !important;
  text-align: left;
}
.el-dialog__header {
  padding: 15px;
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
}
.el-dialog__body {
  padding: 10px 30px 40px;
}
</style>
